import { z } from 'zod';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { isMongoId } from '../../helpers';
import { TransactionOperation } from 'further-types/lp/transaction';

export const currencyRateOverridesSchema = z.record(
  z.nativeEnum(CurrencyCode),
  z.object({
    overrideRate: z.number().optional(),
    overrideSource: z.string().optional(),
  }),
);

export const CreateUnrealisedAssetFXGainOrLossInput = z.object({
  holdingClassInvestments: z.array(
    z.object({
      investmentId: z.string().refine(isMongoId(), {
        message: 'Please provide a valid investment ID',
      }),
      holdingClassId: z.string().refine(isMongoId(), {
        message: 'Please provide a valid holding class ID',
      }),
      transactions: z.array(
        z.object({
          transactionTypeId: z.string().refine(isMongoId(), {
            message: 'Please provide a valid transaction type ID',
          }),
          operationType: z.nativeEnum(TransactionOperation),
        }),
      ),
    }),
  ),
  currencyRateOverrides: currencyRateOverridesSchema.optional(),
});
